/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPANNUALINCOMEBAND = {
    _0_500000: '1',
    _500000_1000000: '2',
    _1000000AndAbove: '3'
} as const;
export type IAPANNUALINCOMEBAND = typeof IAPANNUALINCOMEBAND[keyof typeof IAPANNUALINCOMEBAND];


export function IAPANNUALINCOMEBANDFromJSON(json: any): IAPANNUALINCOMEBAND {
    return IAPANNUALINCOMEBANDFromJSONTyped(json, false);
}

export function IAPANNUALINCOMEBANDFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPANNUALINCOMEBAND {
    return json as IAPANNUALINCOMEBAND;
}

export function IAPANNUALINCOMEBANDToJSON(value?: IAPANNUALINCOMEBAND | null): any {
    return value as any;
}

